export default __webpack_public_path__ + "static/media/slide3.3482a2c8.jpg";